export default "__VITE_ASSET__CQYzfwut__"